import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const InDevelopment = () => {
    const { t } = useTranslation();

    document.title = `${t('Página em Desenvolvimento')} | ProMedico Contabilidade`;

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row className="justify-content-center mt-5">
                        <Col lg={6} md={8}>
                            <Card className="text-center">
                                <CardBody className="p-5">
                                    <div className="mb-4">
                                        <i className="ri-tools-line display-1 text-primary"></i>
                                    </div>
                                    <h1 className="display-5 text-primary mb-3">
                                        {t('Em Desenvolvimento')}
                                    </h1>
                                    <p className="text-muted fs-15 mb-4">
                                        {t('Esta página está atualmente em desenvolvimento. Estamos trabalhando para trazer novos recursos em breve.')}
                                    </p>
                                    <div className="mt-4">
                                        <div className="d-inline-flex align-items-center px-4 py-2 bg-soft-primary rounded">
                                            <i className="ri-time-line fs-18 text-primary me-2"></i>
                                            <span className="text-primary fw-medium">
                                                {t('Por favor, volte em breve')}
                                            </span>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default InDevelopment;
